<template>
    <BaseModal :close="close" :is-open="isOpen">
        <div
            class="bg-white rounded-t-xl lg:rounded-md w-screen md:w-[78vw] xl:w-[45vw] h-full lg:h-auto px-6 pt-9 pb-11 lg:p-16 lg:pb-24"
        >
            <div class="flex flex-col justify-end lg:justify-center text-center relative">
                <div
                    v-if="isForgottenPasswordRequestSent"
                    class="absolute top-0 left bg-white w-full h-full z-10 flex items-center justify-center flex-col p-5"
                >
                    <img
                        class="mb-4 w-16 h-auto"
                        :src="require('~/assets/images/icons/checkmark-icon--green.svg')"
                        :alt="$t('auth.checkmark_alt')"
                    />
                    <div class="w-full lg:w-9/12">
                        <span class="font-Inter-Bold text-[1.5rem] lg:text-2xl mb-3">
                            {{ $t('auth.request_sent.title') }}
                        </span>
                        <p>{{ $t('auth.request_sent.text') }}</p>
                    </div>
                </div>
                <LoginForm />
                <div class="mt-6 pt-5 border-t border-black border-opacity-5 -mb-6 lg:pb-0">
                    <span
                        class="font-OpenSans-Bold hover:underline block cursor-pointer text-black"
                        @click="
                            $store.commit('globals/toggleRegistrationModal', true);
                            $store.commit('globals/toggleLoginModal', false);
                        "
                        >{{ $t('menu.registration') }}</span
                    >
                </div>
            </div>
        </div>
    </BaseModal>
</template>

<script>
import BaseModal from '~/components/UI/BaseModal.vue';
import LoginForm from '@/components/Forms/LoginForm.vue';
export default {
    components: {
        LoginForm,
        BaseModal,
    },
    props: {
        close: {
            type: Function,
            required: true,
        },
        isOpen: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    data() {
        return {
            isForgottenPasswordRequestSent: false,
            isErrorVisible: false,
            newPassword: null,
            registeredEmail: null,
            newPasswordAgain: null,
            registeredUserEmail: null,
            registeredUserPassword: null,
        };
    },
    methods: {
        sendForgottenPasswordRequest() {
            this.isForgottenPasswordRequestSent = true;
        },
    },
};
</script>
